<template>
  <GlassPanel
    v-if="disponibile"
    strong
    :glow="false"
    padding="sm"
    class="fixed right-4 bottom-4 z-50 flex max-w-[calc(100vw-2rem)] items-center gap-3 shadow-xl"
    role="status"
    data-test="aggiornamento-pwa"
  >
    <i class="fal fa-cloud-arrow-down text-accent" aria-hidden="true" />
    <span class="text-sm">{{ t("layout.pwa.nuovi_contenuti") }}</span>
    <UiButton size="sm" icon="fal fa-rotate" :label="t('layout.pwa.ricarica')" @click="emit('ricarica')" />
  </GlassPanel>
</template>

<script setup lang="ts">
// Avviso «nuova versione disponibile» della PWA: si mostra quando il service worker ha contenuti nuovi e ricarica su richiesta.
import { useI18n } from "vue-i18n";

defineProps<{ disponibile: boolean }>();
const emit = defineEmits<{ ricarica: [] }>();
const { t } = useI18n();
</script>
